import React, { Suspense, lazy } from 'react';
import css from './Layout.module.scss';
import { LazyMotion, domAnimation } from 'framer-motion';
import cn from 'classnames';
import Header from '@components/Header/Header';
import Footer from '@components/Footer/Footer';
import AlertBanner from '@components/AlertBanner/AlertBanner';
import ThirdPartyScripts from '../ThirdPartyScripts/ThirdPartyScripts';

const SubscribeModal = lazy(() => import('../SubscribeModal/SubscribeModal'));

// Don't fonget to also change the banner stylings ($bannerHeight and bannerHeightM) in _container.scss
const BANNER_ACTIVE = false;

const Layout = props => {
  const { page, children, className, location, hideNavbar, mode } = props;
  return (
    <LazyMotion features={domAnimation} strict>
      <ThirdPartyScripts />
      <div id="layoutComponent" className={className || css.heightWrapper}>
        <Header page={page} location={location} hideNavbar={hideNavbar} mode={mode} />
        <AlertBanner active={BANNER_ACTIVE} />

        <main
          className={cn(css.container, {
            [css.bg_white]: location?.pathname === '/company/careers/',
          })}
        >
          {children}
        </main>
        <Footer />
        <Suspense fallback={<p>Loading...</p>}>
          <SubscribeModal />
        </Suspense>
      </div>
    </LazyMotion>
  );
};

export default Layout;
